import {put, takeEvery} from "redux-saga/effects";
import {Location} from "../../../Models/Location";
import {locationCreateError, locationCreateSuccess} from "./actions";
import * as TYPES from "./types";

export default function* locationsSagas() {
    yield takeEvery(TYPES.LOCATION_CREATE_REQUEST, locationCreateRequest);
}

function* locationCreateRequest(action) {
    try {
        const response = yield yield Location.create();

        yield put(
            locationCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(locationCreateError(error));
    }
}
